var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashicons:admin-tools"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.3601 19.5403C32.0912 20.8131 30.473 21.6807 28.7107 22.0331C26.9483 22.3856 25.121 22.2071 23.4601 21.5203L12.6401 34.5603C10.6601 36.5403 7.46012 36.5403 5.48012 34.5603C3.50012 32.5803 3.50012 29.3803 5.48012 27.4203L18.5201 16.5803C17.1601 13.2803 17.8201 9.36032 20.5001 6.68032C23.0601 4.12032 26.7401 3.44032 29.9401 4.56032L24.1601 10.3403L29.8001 15.9803L35.5201 10.2403C36.5801 13.4003 35.8801 17.0203 33.3601 19.5403ZM7.62012 32.4203C8.42012 33.2003 9.70012 33.2003 10.4801 32.4203C11.2801 31.6203 11.2801 30.3403 10.4801 29.5603C9.70012 28.7603 8.42012 28.7603 7.62012 29.5603C7.24513 29.9418 7.03501 30.4554 7.03501 30.9903C7.03501 31.5253 7.24513 32.0388 7.62012 32.4203Z",
    fill: "#0A3B70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminTools);
export default __webpack_public_path__ + "static/media/Admin-tools.cd48b3afff256c0a663990de2389a2b2.svg";
export { ForwardRef as ReactComponent };